export default __webpack_public_path__ + "static/media/gallery-wip-neck-ring_01.b3e72d2a.jpg";